// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mirror[data-v-4d4d253c]{\n    /* transform: scaleY(-1) !important; */\n    transform:scale( -1, -1) !important;\n    /* transform: scaleX(1) !important; */\n}\n.mirror-normal[data-v-4d4d253c]{\n    transform: scale(-1, -1) !important;\n    /* transform: scaleX(1) !important; */\n}\n\n", ""]);
// Exports
module.exports = exports;
